module.exports = __webpack_public_path__ + "static/media/ic_build_black_24px.ff523bf9.svg";